import { MaterialDto } from "@dashboard/modules/material-management/material/model/material.dto";
import { UnitSetDto } from "@dashboard/modules/material-management/unit-set/model/unit-set.dto";
import { CurrencyDto } from "@app/data/management/models/currency.dto";
import { BillingLineDiscountDto } from "@app/modules/shared/model/billing/billing-line-discount.dto";
import { VatRateDto } from "@dashboard/modules/application-params/vat-rate/model/vat-rate.dto";

export class BillingLineDto {
  id?: number;
  external_id: string;
  line_type: string;
  material: MaterialDto;
  unit_set: UnitSetDto;
  unit_set_unit: any;
  unit_multiplier: number;
  currency: CurrencyDto;
  exchange_rate: number;
  currency_price: number;
  vat_group: VatRateDto;
  vat_rate: number;
  vat_included: string;
  quantity: number;
  price: number;
  net_price: number;
  discount_amount: number;
  document_disc_amount: number;
  discount_rate: string;
  expense_amount: number;
  document_expense_amount: number;
  expense_rate: string;
  vat_amount: number;
  without_vat_amount: number;
  net_total_amount: number;
  gross_total_amount: number;
  warehouse: any;
  in_out: string;
  rec_status?: string;
  local_price?: number;
  deduction_amount?: number;
  deduction1?: number;
  deduction2?: number;
  calculation_type?: string;
  expense_rate_type?: string;
  discounts: Array<BillingLineDiscountDto>;
}
